// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tD6VShb2ReWa67 {
  border-radius: 3px;
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: jdJkXNUTmHnHkN;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  width: 80px;
  height: 16px;
  margin-top: var(--ds-space-200, 16px);
}
@keyframes jdJkXNUTmHnHkN {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .tD6VShb2ReWa67 {
    animation: none;
  }
}
.abQqT2uMFymB3M {
  border-radius: 3px;
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: jdJkXNUTmHnHkN;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  width: 100%;
  height: 36px;
  margin: var(--ds-space-050, 4px) var(--ds-space-0, 0);
}
@keyframes jdJkXNUTmHnHkN {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .abQqT2uMFymB3M {
    animation: none;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"skeletonHeader": `tD6VShb2ReWa67`,
	"shimmer": `jdJkXNUTmHnHkN`,
	"skeletonRow": `abQqT2uMFymB3M`
};
export default ___CSS_LOADER_EXPORT___;
